import React from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const handleToggle = () => {
    document.body.classList.toggle("sidebar-icon-only");
  };
  const navigate = useNavigate();
  const className = sessionStorage.getItem("className") || "";

  const movetologin = (e) => {
    e.preventDefault();
    const items = document.querySelectorAll("li.nav-item");
    items.forEach((item) => item.classList.remove("active"));
    e.currentTarget.classList.add("active");
    sessionStorage.clear();
    navigate("/secondary-accounts");
  };
  const movetodashboard = () => {
    const items = document.querySelectorAll("li.nav-item");
    items.forEach((item) => item.classList.remove("active"));
    if (sessionStorage.getItem("className") === "CLASS_9") {
      navigate("/secondary-accounts-dashboard-class-ix");
    } else {
      navigate("/secondary-accounts-dashboard-class-x");
    }
  };

  return (
    <>
      <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center">
          <a
            class="navbar-brand brand-logo"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              movetodashboard();
            }}
          >
            <img
              src="../assets/images/jac-academic-council.png"
              class="me-2"
              alt="logo"
            />
          </a>
          <h5 class="mt-3">Jharkhand Academic Council</h5>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
          <button
            className="navbar-toggler navbar-toggler align-self-center"
            type="button"
            onClick={handleToggle}
          >
            <span className="icon-menu"></span>
          </button>
          <span
            className="text-danger"
            style={{
              textTransform: "uppercase",
              marginLeft: 15,
              fontWeight: 600,
              fontSize: 18,
              marginTop: 5,
            }}
          >
            <span style={{ fontSize: 16 }}>Secondary Accounts Portal</span>{" "}
            &nbsp;|&nbsp;
            <span style={{ fontSize: 16 }}>Year - 2026 (Annual)</span>{" "}
            &nbsp;|&nbsp;
            <span style={{ fontSize: 16 }}>
              CLASS {className == "CLASS_9" ? "IX" : "X"}{" "}
            </span>
          </span>
          <ul class="navbar-nav navbar-nav-right">
            <li class="nav-item nav-profile dropdown">
              <a
                class="dropdown-item logout"
                href="#"
                onClick={(e) => movetologin(e)}
              >
                <i class="ti-power-off text-primary"></i> Logout{" "}
              </a>
            </li>
          </ul>
          <button
            class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
          >
            <span class="icon-menu"></span>
          </button>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
